import cliAuth from './axios_cli';

export default async function PostData(
  data,
  procName,
  url,
  setSuccessMessage,
  setSuccessStatus,
  setOpenSuccessBar,
  setErrorMessage,
  setErrorStatus,
  setOpenErrorBar,
  onSuccess,
  onError
) {
  await cliAuth.post(url, data)
    .then(response => {
      onSuccess(response, '登録', setSuccessMessage)
      console.log(url + ' post success', response)
      // setSuccessMessage(`${procName}を登録しました`)
      setSuccessStatus('success')
      setOpenSuccessBar(true)
    })
    .catch(err => {
      if (err.response === undefined) {
        setErrorMessage(`${procName}の登録に失敗しました`)
      } else {
        console.log(err)
        onError(err, '登録', setErrorMessage)
      }
      setErrorStatus('error')
      setOpenErrorBar(true)
      console.log(err)
    })
}